/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import PageSection from "components/PageSection";
import pageHeaderCss from "./index.css";

export default function PageHeader({ title, children }) {
  return (
    <PageSection css={pageHeaderCss.container}>
      <h1 css={pageHeaderCss.header} className="main-title">
        {title}
      </h1>

      {children}
    </PageSection>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
